import React from "react";
import { Link } from "react-router-dom";

class AnyQuestions extends React.Component {
  render() {
    return (

      <section className="section QASection">
        <div className="container">
          <div className="row">

            <div className="col-md-12"><div className="line"></div></div>
            <div style={{ clear: "both", height: "15px" }} />

            <div className="col-lg-10">
              <div className="text-left">
                <h4 className="SansSerif bold600">Any Question? Need Help?</h4>
                <p className="mx-auto pt-2">
                  <span><i className="mdi mdi-comment-multiple-outline" /> <span className="bold600">CALL US:</span> 201-731-3839 (9AM - 6PM EST)</span>&nbsp;&nbsp;&nbsp;
                  <span className="m-break"><i className="mdi mdi-email-outline" /> <span className="bold600">EMAIL US:</span> SUPPORT@mightywifi.net</span>
                </p>
              </div>
            </div>

            <div className="col-lg-2">
              <p className="mx-auto text-right cta-desc mt-4">
                <Link
                  to="/contact-us"
                  className="btn btn-custom-contact btn-white"
                >
                  Contact us
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

    );
  }
}

export default AnyQuestions;



// WEBPACK FOOTER //
// ./src/reusable/AnyQuestions.js